import * as React from "react";
const SvgFiRrBookTanakh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4V5c0-2.757-2.243-5-5-5M7 2h10c1.654 0 3 1.346 3 3v11.556A3.95 3.95 0 0 0 18 16H4V5c0-1.654 1.346-3 3-3m11 20H7c-1.654 0-3-1.346-3-3v-1h14c1.103 0 2 .897 2 2s-.897 2-2 2"
    />
    <path
      fill="#062147"
      d="M6.08 12.255a.5.5 0 0 0 .435.255h3.378l1.68 2.755a.5.5 0 0 0 .854 0l1.68-2.755h3.378a.501.501 0 0 0 .427-.76l-1.67-2.742 1.67-2.738a.499.499 0 0 0-.428-.76h-3.373l-1.684-2.766c-.182-.298-.673-.298-.854 0L9.89 5.51H6.516a.5.5 0 0 0-.427.76l1.67 2.738-1.67 2.742a.5.5 0 0 0-.01.505M12 14.044l-.936-1.534h1.871zm-1.545-2.534L8.93 9.008 10.45 6.51h3.1l1.52 2.498-1.526 2.502h-3.09zm4.262 0 .94-1.541.94 1.541zm1.878-5-.937 1.537-.936-1.537zm-4.594-2.544.94 1.544h-1.88zM7.407 6.51H9.28l-.936 1.537zm.938 3.459.94 1.541H7.407z"
    />
  </svg>
);
export default SvgFiRrBookTanakh;
